<template>
  <div class="" style="z-index: 70000">
    <div v-for="i in 7" :key="i + 'xp'" class="ele xp_ele">
      <img src="@/assets/images/icons/tokens/xp.svg" />
    </div>

    <div v-for="i in 5" :key="i + 'gold'" class="ele gold_ele">
      <img src="@/assets/images/icons/tokens/gold-coin.svg" />
    </div>
  </div>
</template>

<script>
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default {
  data() {
    return {
      all_ele: null,
    };
  },
  computed: {
    xpFinalPosition() {
      return this.$store.state.animation.xpFinalPosition;
    },
    xpInitialPosition() {
      return this.$store.state.animation.xpInitialPosition;
    },
    goldFinalPosition() {
      return this.$store.state.animation.goldFinalPosition;
    },
    goldInitialPosition() {
      return this.$store.state.animation.goldInitialPosition;
    },
    isAnimationTrue() {
      return this.$store.state.animation.isAnimationTrue;
    },
  },

  watch: {
    isAnimationTrue: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (newVal) {
            this.animationXp();
            this.animationGold();
        }
      },
    },
  },

  methods: {
    animationXp() {

      setTimeout(() => {

      const item = "xp" + "_ele";
      this.all_ele = document.querySelectorAll("." + item);
      //   const i = document.getElementById("coin" + "_1");
      //   const ip = i.getBoundingClientRect();
      //   const f = document.getElementById("coin" + "_f");
      //   const fp = f.getBoundingClientRect();
      const ip_top = this.xpInitialPosition.top + window.scrollY;
      const ip_left = this.xpInitialPosition.left;
      const ip_bottom = this.xpInitialPosition.bottom;
      const ip_right = this.xpInitialPosition.right;
      const fp_top = this.xpFinalPosition.top + window.scrollY;
      const fp_left = this.xpFinalPosition.left;
      const fp_bottom = this.xpFinalPosition.bottom;
      const fp_right = this.xpFinalPosition.right;
      this.animationStart(
        ip_top,
        ip_left,
        ip_bottom,
        ip_right,
        fp_top,
        fp_left,
        fp_bottom,
        fp_right
      );

       }, 10);
    },

    animationGold() {

      setTimeout(() => {

        const item = "gold" + "_ele";
        this.all_ele = document.querySelectorAll("." + item);
        //   const i = document.getElementById("coin" + "_1");
        //   const ip = i.getBoundingClientRect();
        //   const f = document.getElementById("coin" + "_f");
        //   const fp = f.getBoundingClientRect();
        const ip_top = this.goldInitialPosition.top + window.scrollY;
        const ip_left = this.goldInitialPosition.left;
        const ip_bottom = this.goldInitialPosition.bottom;
        const ip_right = this.goldInitialPosition.right;
        const fp_top = this.goldFinalPosition.top + window.scrollY;
        const fp_left = this.goldFinalPosition.left;
        const fp_bottom = this.goldFinalPosition.bottom;
        const fp_right = this.goldFinalPosition.right;

        this.animationStart(
          ip_top,
          ip_left,
          ip_bottom,
          ip_right,
          fp_top,
          fp_left,
          fp_bottom,
          fp_right
        );

      }, 10);

    },
    initialpos(ip_top, ip_left, ip_bottom, ip_right) {
      this.all_ele.forEach(function (ele) {
        ele.style.top =
          ip_top + gsap.utils.random(30, 40) * gsap.utils.random(-1, 1) + "px";
        ele.style.left =
          ip_left + gsap.utils.random(30, 40) * gsap.utils.random(-1, 1) + "px";
        ele.style.bottom =
          ip_bottom +
          gsap.utils.random(30, 40) * gsap.utils.random(-1, 1) +
          "px";
        ele.style.right =
          ip_right +
          gsap.utils.random(30, 40) * gsap.utils.random(-1, 1) +
          "px";
      });
    },

    animationStart(
      ip_top,
      ip_left,
      ip_bottom,
      ip_right,
      fp_top,
      fp_left,
      fp_bottom,
      fp_right
    ) {
      this.initialpos(ip_top, ip_left, ip_bottom, ip_right);

      const tl = gsap.timeline({
        defaults: {
          duration: 1,
          ease: "rough",
          repeat: 0,
        },
      });

      tl.staggerFromTo(
        this.all_ele,
        0.7,
        { duration: 0, display: "block", opacity: 0, scale: 0.8 },
        {
          duration: 0,
          display: "block",
          opacity: 1,
          ease: "back.out(1)",
          stagger: 0.3,
        }
      );

      tl.staggerFromTo(
        this.all_ele,
        1.3,
        { duration: 0, display: "block", scale: 0.8 },
        {
          duration: 1,
          display: "none",
          ease: "power3",
          top: fp_top,
          left: fp_left,
          bottom: fp_bottom,
          right: fp_right,
          scale: 0.6,
          opacity: 0,
          stagger: 0.01,
        }
      );
      this.$store.commit("animation/SET_ANIMATION_STATUS", false);
    },
  },
};
</script>

<style lang="scss" scoped>
.ele {
  position: absolute;
  width: 3rem;
  height: 3rem;
  z-index: 60000 !important;
  bottom: 0;
  display: none;
}

.ele img {
  width: 100%;
  height: 100%;
}
</style>
